<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    :type="modalType"
    class="ModalTopicFromUrl"
    title="Load from URL"
    submit-name="Check"
    @submit="submit"
    @timed-out="errored('server')"
    @submit-fails="errored('server')"
  >
    <p class="text-gray-700">
      Paste the URL from any news article, blog post, or web based media and we
      will fetch the information available and fill your topic.
    </p>
    <lm-input
      ref="inputUrl"
      class="Title"
      label="URL"
      :maxlength="0"
      focus
      @focus="showErrorMessage = false"
      @submit="submitFromInput()"
    />
    <div v-if="showErrorMessage" class="flex mb-0">
      <lm-icon icon="warning" size="21" class="flex-shrink-0 mr-2 text-error" />
      <p class="text-gray-700 text-s">
        <template v-if="errorType === 'validation'">
          You can copy and paste the URL directly from your browser's direction
          bar, for example:
          <span class="italic font-medium font-mono bg-gray-300"
            >https://news.com/amazing-article</span
          >
        </template>
        <template v-else>
          Sorry but we are unable to retrieve information from this URL. As an
          alternative, <span class="font-medium">Cancel</span> and manually copy
          the title and text of the article.
        </template>
      </p>
    </div>
  </form-modal>
</template>

<script>
import EventHub from '@/lib/eventHub'
import {Modal, ModalType, Events} from '@/lib/definitions'
import FormHelper from '@/components/form/formHelper'
import LmInput from '@/components/form/LmInput'
import FormModal from '@/components/modals/FormModal'
import LmIcon from '@/components/ui/LmIcon'
import {urlRegExp} from '@/components/form/editor/mediaHelpers'

export default {
  name: 'ModalTopicFromUrl',
  components: {
    FormModal,
    LmInput,
    LmIcon
  },
  data() {
    return {
      Events,
      modalName: Modal.TOPIC_FROM_URL,
      modalType: ModalType.SUBMODAL,
      showErrorMessage: false,
      errorType: null
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
  },
  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    errored(type) {
      this.errorType = type
      this.showErrorMessage = true
      if (this.$refs?.inputUrl) {
        this.$refs.inputUrl.error = true
        this.$refs.inputUrl.errorMessage =
          type === 'validation'
            ? 'Please input a valid URL'
            : 'Unable to retrieve information'
      }
    },
    submit() {
      const url = this.$refs.inputUrl.data
      if (FormHelper.validate([this.$refs.inputUrl]) && url.match(urlRegExp)) {
        this.$store
          .dispatch('topicFromUrl', url)
          .then(data => {
            EventHub.emit(Events.TOPIC_FROM_URL, data)
            this.modalRef.submitSuccess()
          })
          .catch(error => {
            this.errored('server')
            if (error.devCode !== 500) {
              error = error.devMessage
            }
            this.modalRef.submitFails(error)
          })
      } else {
        this.errored('validation')
        this.modalRef.submitFails()
      }
    }
  }
}
</script>

<style>
.ModalTopicFromUrl {
  .Modal-wrapper {
    width: 600px;
    .Modal-body {
      height: 260px;
    }
  }
}
</style>
